import type { QueryClient } from '@tanstack/react-query';
import { onDataWrite } from '@/shared/api/dataWrites';
import { dropAllRetainedResults } from './useRetainedSearch';

/**
 * slice-3952 (#3780 New Area, #3785 New User, #3799/#3800 Delete User, #3803 New Vendor,
 * #3823 New Pick Doc Form): after a successful data write anywhere in the tab, every list grid
 * re-reads the next time it is shown — PB's re-retrieve on return to the list window.
 *
 * Two caches held the old rows, so both are handled:
 *  1. TanStack — every `['browse', …]` query is invalidated with `refetchType: 'none'`: marked
 *     stale, NOT refetched. The page that made the write already refetches its own grid; any
 *     other list re-reads exactly once, on its next mount (`refetchOnMount`), showing its old
 *     rows until the fresh ones land so scroll / selection restore still has rows to land on.
 *  2. The slice-3572 retained seed in `sessionStorage` (which also survives an F5) — rows are
 *     dropped, criteria + view kept ({@link dropAllRetainedResults}).
 *
 * A Back from a pure drill (no write in between) is untouched: still instant, no re-hit.
 * Returns the unsubscribe function.
 */
export function installStaleOnDataWrite(queryClient: QueryClient): () => void {
  return onDataWrite(() => {
    void queryClient.invalidateQueries({ queryKey: ['browse'], refetchType: 'none' });
    dropAllRetainedResults();
  });
}
